module.exports = __webpack_public_path__ + "static/media/gcc.5de9c12d.webp";